<template>
  <div class="view_top flex">
    <div class="left flex">
      <span class="left_icon"> </span>
      <ul class="topBox flex">
        <div>
          <el-breadcrumb separator="-">
            <el-breadcrumb-item v-for="(item, index) in historyArr" :key="index">{{ item }}</el-breadcrumb-item>

          </el-breadcrumb>
        </div>


        <div class="rightBox">
          <slot></slot>
        </div>

      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    historyArr: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
};
</script>

<style lang="less" scoped>
/* 头部起始位置 */

.topBox {
  width: 100%;
  justify-content: space-between;

}

.left{
  width: 100%;
}

.rightBox {
  margin-right: 10px;
}

.view_top {
  width: 100%;
  height: 50px;
  line-height: 50px;
  margin: auto;
  justify-content: space-between;
  border-bottom: 2px solid #bebebe;
  padding: 0px 10px;
  box-sizing: border-box;

  .el-breadcrumb {
    display: flex;
    align-items: center;
  }


  .left_icon {
    width: 4px;
    height: 20px;
    background: #999;
    display: inline-block;
    margin-right: 10px;
  }
}

/* 头部结束位置 */
</style>


// WEBPACK FOOTER //
// src/components/historyTag.vue